import { Component, ChangeDetectionStrategy, ChangeDetectorRef, OnInit } from '@angular/core';
import { SampleTrackingStorage } from '../../sample-tracking-storage';
import { UserStorage, User } from '../../../user';
import { map, concatMap } from 'rxjs/operators';
import { CategoryNaturalKey } from '../../../documents';
import { forkJoin } from 'rxjs';
import { EmailPreferenceReadModel, EmailPreferenceCategory } from '../../../user/email-preferences/email';

@Component({
    selector: 'app-user-settings',
    template: require('./user-settings.component.html'),
    styles: [require('./user-settings.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SampleTrackingUserSettings {

    public emailPreferences: EmailPreferenceReadModel;
    public emailPrefCategories: EmailPreferenceCategory[];
    public sampleTrackingCategory: EmailPreferenceCategory;
    public preferences: { id: number, value: string }[] = [
        { id: 0, value: 'None' },
        { id: 1, value: 'Daily' },
        { id: 2, value: 'Immediate' },
    ];
    public selectedOption: any;
    private currentUser: User;
    private categoryId: CategoryNaturalKey = 'sample-tracking';
    

    constructor(
        private userStorage: UserStorage,
        private sampleTrackingStorage: SampleTrackingStorage,
        private changeDetecterRef: ChangeDetectorRef) {

        this.userStorage.currentUser.
            pipe(
                map(user => {
                    this.currentUser = user;
                    return user;
                }),
                concatMap((user) =>
                    forkJoin([
                        this.sampleTrackingStorage.getUserEmailPreferences(user),
                        this.sampleTrackingStorage.loadEmailPreferenceCategories(user)
                    ]),
                ),
                map(([emailPreferences, emailCategories]) => {
                    this.emailPrefCategories = emailCategories;
                    this.sampleTrackingCategory = emailCategories.filter(t => t.categoryId === this.categoryId).map(t => t)[0];
                    if (emailPreferences) {
                        this.emailPreferences = emailPreferences;
                        let value = emailPreferences.emailPreferences.filter(t => t.categoryId === this.categoryId)[0];
                        if (value) {
                            this.selectedOption = this.preferences.filter(t => t.id === value.prefValue);
                        }
                    }
                })
            ).subscribe(() => {
                    this.changeDetecterRef.markForCheck();
                });

    }

    public onEmailPreferenceChange(selectedValue: { id: number, value: string }[]) {
        if (!this.emailPreferences) { return; }
        if (!selectedValue && selectedValue.length === 0) { return; }
        let emailPref = this.emailPreferences.emailPreferences.filter(pref => pref.categoryId === this.sampleTrackingCategory.categoryId)[0];
        emailPref.prefValue = selectedValue[0].id;
        this.sampleTrackingStorage.saveEmailPreferences([emailPref], this.currentUser.metadata.userId);
    }
}